class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.itemMenu = document.querySelectorAll('.header-wrapper a.header__menu-item');
    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.closest('#shopify-section-header').addEventListener('mouseleave', this.onMouseLeave.bind(this));

    for (const item of this.itemMenu) {
      item.addEventListener('mouseenter', this.onRemoveActive.bind(this));
    }
  }

  onToggle() {
    if (!this.header) return;
    this.detailsToggled(this.mainDetailsToggle)
    this.header.preventHide = this.mainDetailsToggle.open;
    (this.header.preventHide) ?
      this.header.classList.add('transparent-menu-open') :
      this.header.classList.remove('transparent-menu-open')

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }


  detailsToggled(e) {
    if (typeof e === "undefined" || e.open) return;

    this.mainDetailsToggle = document.createElement("details");
    this.mainDetailsToggle.innerHTML = e.innerHTML;
    this.mainDetailsToggle.classList.add(e.classList)
    this.mainDetailsToggle.setAttribute('id', e.getAttribute('id'))
    e.parentNode.replaceChild(this.mainDetailsToggle, e);

    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.closest('#shopify-section-header').addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onRemoveActive() {
    for (const itemMegaMenu of this.header.querySelectorAll('details')) {
      itemMegaMenu.removeAttribute('open');
      itemMegaMenu.querySelector('summary').setAttribute('aria-expanded', false);
    }
  }

  onMouseEnter() {
    for (const itemMegaMenu of this.header.querySelectorAll('details')) {
      itemMegaMenu.removeAttribute('open');
      itemMegaMenu.querySelector('summary').setAttribute('aria-expanded', false);
    }
    this.mainDetailsToggle.setAttribute('open', '')
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true')
  }

  onMouseLeave() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }
}

customElements.define('header-menu', HeaderMenu);
